export default "__VITE_ASSET__BASeX0b3__"